//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Base from './rb-base.vue'
const DEFAULT_SELECT_ARIA_LABEL = 'send-us-message'
export default {
  name: 'rb-select',
  extends: Base,
  props: {
    id: {
      type: String,
    },
    type: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    name: {
      type: String,
    },
    initialvalue: {
      type: String,
    },
    label: {
      type: String,
    },
    helper: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
    autocomplete: {
      type: Boolean,
    },
    sronly: {
      type: String,
    },
    arialabel: {
      type: String,
    },
    hidehelpervalue: {
      type: String,
    },
  },
  computed: {
    selectAriaLabel() {
      return this.arialabel ? this.arialabel : DEFAULT_SELECT_ARIA_LABEL
    },
  },

  methods: {
    onChange(eventObj) {
      this.helperIsVisible = this.hidehelpervalue !== eventObj.target.value
      this.$emit('onSelectChange', eventObj)
    },
    onBlur(eventObj) {
      this.$emit('onSelectBlur', eventObj)
    },
    onFocus(eventObj) {
      this.$emit('onSelectFocus', eventObj)
    },
  },
}
